<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Approval/Task Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col :class="this.isPreview==true?'col-md-5':'col-md-12'">
                    <!-- <b-input-group >
                        <b-input-group-prepend><label>Doc./Task Name</label></b-input-group-prepend>
                        <b-form-input v-model="model.wftypekey" readonly></b-form-input>
                    </b-input-group> -->
                    <b-input-group >
                        <b-input-group-prepend><label>Doc./Task Detail</label></b-input-group-prepend>
                        <b-form-textarea :rows="3" :max-rows="10" v-model="model.taskdetail" readonly></b-form-textarea>
                    </b-input-group>

                    <b-input-group >
                        <b-input-group-prepend><label>Requested By</label></b-input-group-prepend>
                        <b-form-input v-model="model.createdby" readonly></b-form-input>                                        
                        <b-form-input v-model="model.createdon" readonly class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-col lg="12" style="display: flex;justify-content: right;">
                        <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a>
                    </b-col>
                    <b-row no-gutters>
                        <b-col cols="6">
                            <label>Attachments</label>
                            <!-- <b-link @click="showAddAttachment=true" class="ml-2"><i class="fa fa-paperclip"></i> Add</b-link> -->

                        </b-col>
                        <!-- <b-col cols="6">
                            <div class="text-right">
                                <b-button variant="secondary" class="ml-1" size="sm" @click="viewBudgetProd">View Project/Production Budget</b-button>       
                            </div>                    
                        </b-col> -->
                    </b-row>
                    <div class="ml-4 mb-2">
                        <ol style="margin:0" v-if="(attachments.length>0)">
                            <li v-for="fl in attachments" :key="fl.attachmentKey">
                                <b-link @click="attachmentDownload(fl)">{{fl.attchFileNm}}</b-link>
                            </li>
                        </ol>
                        <ul style="margin:0" v-else>
                            <li>no attachment</li>
                        </ul>
                    </div>
                    <div v-if="(attachments.length>0)">
                        <b-alert show variant="warning">
                            <span style="color:black !important; font-style:italic;">
                                *Memo ini memiliki attachment, silahkan klik link attachment di atas untuk melihatnya.
                            </span>
                        </b-alert>
                    </div>
                    <div v-show="(historyb4 && historyb4.length>0)">
                        <br>
                        <label><b>Workflow History Before ({{titleb4}})</b></label>
                        <label><b>Nilai Pengajuan Sebelumnya: Rp. {{ttlmustpay | numFormat("0,0.00")}}</b></label>
                        <div class="report-wraper">
                            <table width="100%">
                            <thead>
                            <tr>
                            <th width="120px">Assign Date</th>
                            <th width="120px">Assign To</th>
                            <th width="80px">Action Take</th>
                            <th width="120px">Comment</th>
                            <th width="120px">Complete Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="row in historyb4" :key="row.taskassignkey">
                            <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                            <td>{{row.crewinfo}}</td>
                            <td>{{row.actiontake}} </td>
                                <!-- <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td> -->
                            <td>{{row.actiontake}} alasan: {{row.message}}</td>
                            <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                            </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <span :class="this.taskname=='APPROVAL-RRD REQUEST'?'d-block float-right':'d-none'"><a :href="viewrequestdetail(this.model.requestkey)" target="_blank" title="View Request RRD"><i class="fa fa-eye"></i> View Request RRD</a></span>
                    
                    <div v-if="(model.type_memo=='banding')">
                        <b-alert show variant="warning">
                            <span style="color:black !important; font-style:italic;">
                                *Memo ini adalah <strong>MEMO BANDING</strong>, silahkan cek history memo sebelumnya pada tampilan print disamping
                            </span>
                        </b-alert>
                    </div>

                    <div v-show="((showForm==false) && (showQueue==false))">
                        <br />
                            <div class="ml-5 mb-2" v-if="(owneridx==0)">
                                <p>Your Comment</p>

                            <b-form-textarea :rows="3" :max-rows="10" v-model="model.message" :state="!$v.model.message.$error" v-if="(model.state == 'COMPLETED')" disabled ></b-form-textarea>
                            <b-form-textarea :rows="3" :max-rows="10" v-model="model.message" :state="!$v.model.message.$error" v-else ></b-form-textarea>

                            </div>
                            <b-row class="justify-content-center mt-2 mb-2" v-if="(model.isTask==0)">
                                <b-button variant="success" @click="doAction('APPROVED')" v-if="(model.state == 'COMPLETED')" disabled >Approve</b-button>
                                <b-button variant="success" @click="doAction('APPROVED')" v-else >Approve</b-button>
                                <b-button variant="danger" class="ml-1" @click="doAction('REJECTED')" v-if="(model.state == 'COMPLETED')" disabled >Reject</b-button>
                                <div v-else>
                                    <b-button variant="warning" class="ml-1" @click="doAction('APPROVED',true)" v-if="(owneridx>0) && (model.type_memo=='normal')" >Suggest</b-button>
                                    <b-button variant="outline-danger" class="ml-1" @click="doAction('REJECTED')" style="min-width:70px" v-b-tooltip.hover title="REJECT">
                                        <i class="fa fa-exclamation-circle"></i>
                                    </b-button>

                                </div>
                                

                            </b-row>
                            <b-row class="justify-content-center mt-2 mb-2" v-if="(model.isTask==1)">
                                <b-button variant="success" class="ml-1" @click="doAction('COMPLETED')">Complete</b-button>
                                <!-- <b-button variant="warning" class="ml-1" @click="doAction('REVIEWED')">Review</b-button> -->
                                <!-- <b-button variant="info" class="ml-1" @click="showRouting">Routing</b-button> -->
                                <!-- <b-button variant="dark" class="ml-1" @click="showQueuing">Queued</b-button>
                                <b-button variant="primary" class="ml-1" @click="doAction('PROCESSED')">Started</b-button> -->
                                <b-button variant="outline-danger" class="ml-1" @click="doAction('REJECTED')">Reject</b-button>
                            </b-row>
                    </div>
                    <div v-show="(showForm==true)">
                        <b-card >
                            <div slot="header">Routing Approval/Task 
                            </div>
                            <b-input-group >
                                <b-input-group-prepend><label>Route to</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.routeToNik.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuUserShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Your Comment</label></b-input-group-prepend>
                                <b-form-textarea :rows="3" :max-rows="3" v-model="model.message" :state="!$v.model.message.$error" ></b-form-textarea>
                            </b-input-group>
                            <b-row class="justify-content-center mt-1" >
                                <b-button variant="primary" @click="doRouting"><i class="fa fa-check"></i> Proceed Routing</b-button>
                                <b-button variant="secondary" class="ml-1" @click="closeRouting()" > <i class="fa fa-close"></i> Cancel Routing</b-button>
                            </b-row>
                        </b-card>
                    </div>
                    <div v-show="(showQueue==true)">
                        <b-card >
                            <div slot="header">Queuing Approval/Task 
                            </div>
                            <b-input-group >
                                <b-input-group-prepend><label>Est. Start Date</label></b-input-group-prepend>
                                <b-form-input type="date" v-model="model.postuntil" :state="!$v.model.postuntil.$error"></b-form-input>
                                <b-input-group-append><span class="input-group-text" > wait in Queue til the date</span></b-input-group-append>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Your Comment</label></b-input-group-prepend>
                                <b-form-textarea :rows="3" :max-rows="3" v-model="model.message" :state="!$v.model.message.$error" ></b-form-textarea>
                            </b-input-group>
                            <b-row class="justify-content-center mt-1" >
                                <b-button variant="primary" @click="doQueuing"><i class="fa fa-check"></i> Proceed Queuing</b-button>
                                <b-button variant="secondary" class="ml-1" @click="closeQueuing()" > <i class="fa fa-close"></i> Cancel Queuing</b-button>
                            </b-row>
                        </b-card>
                    </div>
                    <label>Workflow History Current</label>
                    <div class="report-wraper">
                        <table width="100%">
                        <thead>
                        <tr>
                        <th width="120px">Assign Date</th>
                        <th width="120px">Assign To</th>
                        <!-- <th width="80px">Action Take</th> -->
                        <th width="120px">Comment</th>
                        <th width="120px">Complete Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="row in history" :key="row.taskassignkey">
                        <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                        <td>{{row.crewinfo}}</td>
                        <!-- <td>{{row.actiontake}} </td>
                            <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p> -->
                        <td>{{ row.actiontakeLabel }} alasan: {{ row.message }}</td>
                        <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                        </tr>
                        </tbody>
                        </table>
                    </div>
                </b-col>
                <b-col :class="this.isPreview==true?'col-md-7':'col-md-0'">
                    <b-card no-body v-show="(isPreview==true)">
                        <b-tabs pills card content-class="mt-3" v-if="((pelunasanDetail.referencekey||'')!='')">
                            <b-tab title="MEMO BANDING" active>
                                <iframe :src="reportUrl" frameborder="0"></iframe>
                            </b-tab>
                            <b-tab title="MEMO SEBELUMNYA">
                                <iframe :src="reportbeforeUrl" frameborder="0"></iframe>                                
                            </b-tab>
                        </b-tabs>
                        <div v-else>
                            <iframe :src="reportUrl" frameborder="0"></iframe>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>

        <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Confirm" size="md" :centered="true" hide-footer>
          <b-row>
              <b-col cols="12">
                  <b-input-group>
                      <b-input-group-prepend>
                          <label style="text-align:center;" v-if="this.model.actionname=='APPROVED'">
                            Are you sure want to
                                <span v-if="(model.type_memo=='normal') && (model.actionwithnote)"><b>SUGGEST</b></span>
                                <span v-else><b>APRROVED</b></span>
                                it?
                          </label>
                          <label style="text-align:center;" v-else>Are you sure want to <b>REJECTED</b> it?</label>
                      </b-input-group-prepend>
                </b-input-group>
                <div  v-if="(owneridx>0) && (model.type_memo=='normal') && (model.actionwithnote)">
                    <b-input-group>
                        <b-input-group-prepend><label>Nilai Pelunasan</label></b-input-group-prepend>
                        <my-number
                            class="form-control text-right my-number"
                            separator=","
                            v-model="model.finalNilaiPelunasan"
                            :precision="2"
                            style="max-width: 200px;"
                            ></my-number>                                       
                    </b-input-group>
                    <b-input-group v-if="(model.tipepelunasan!='Normal')">
                        <b-input-group-prepend><label>Tanggal Pelunasan</label></b-input-group-prepend>
                        <b-form-input type="date" v-model="model.finalTglPelunasan" style="max-width: 200px;"></b-form-input>                                        
                    </b-input-group>
                </div>
                <div v-if="((finalApproval && (model.actionwithnote || model.actionname=='REJECTED')) || owneridx>0)">
                    <p>Your Comment</p>
                    <b-form-textarea :rows="3" :max-rows="10" v-model="model.message" :state="!$v.model.message.$error" v-if="(model.state == 'COMPLETED')" disabled ></b-form-textarea>
                    <b-form-textarea :rows="3" :max-rows="10" v-model="model.message" :state="!$v.model.message.$error" v-else :placeholder="(model.actionname=='APPROVED' && model.actionwithnote)?'Contoh : Setuju di nominal .... ':''"></b-form-textarea>
                </div>
              </b-col>
          </b-row >
          <hr>
          <div>
              <b-row class="justify-content-end mt-4" >
                  <b-button variant="secondary" @click="showApprovalConfirm=false">Cancel</b-button>
                  <b-button variant="primary" class="ml-2 mr-3" @click="approval"><i class="fa fa-check"></i> OK</b-button>
              </b-row>
          </div>
        </b-modal>

        <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of User/Employee" :centered="true">
            <lku-user @click="onSelectLkuUser"></lku-user>
        </b-modal>        
    <b-modal v-model="budgetShow" size="lg" :title="budgetTitle" ok-only>
        <iframe :src="budgetUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showAddAttachment" header-bg-variant="primary"  title="Add Attachment Form" size="lg" :centered="true" @ok="attachmentSave" ok-title="Save">
        <b-form @submit.stop.prevent="attachmentSave">
            <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div>        </b-form>
      </b-modal>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>    
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }

</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuUser from "../lookup/lkuUser";
import task from "../../apis/task";
import pelunasan from "../../apis/pelunasanpinjaman";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, Loading, lkuUser},
  mixins: [validationMixin],
  validations: {
        model: {
            taskassignkey: { required },
            message: { required },
            // { required : (function() {
            //     if(this.finalApproval){
            //         return true;
            //     }else{
            //         if((this.model.message||'')!=''){
            //             return true;
            //         }else{
            //             return false;
            //         }
            //     }
            // }) },
            routeToNik: {required : (function() {
                if (this.model.isrouting == 0) {
                    return true;
                } else if (!(this.model.routeToNik)){
                    return false;
                } else return true;
            })},
            postuntil: {required : (function() {
                if (this.model.postponed == 0) {
                    return true;
                } else if (!(this.model.postuntil)){
                    return false;
                } else return true;
            })},
        },
        // file: { required },
  }, 
  data() {
    return {
       isLoading:false,
        lkuUserShow:false,
        showQueue:false,
        showForm:false,
        reportUrl: `${location.origin}/#load`,
        reportbeforeUrl: `${location.origin}/#load`,
        budgetShow:false,
        budgetUrl: `${location.origin}/#load`,
        budgetTitle: `Preview Annual Budget`,
        showAddAttachment:false,
        showApprovalConfirm: false,
        model:{message:'', isrouting:0, routeToNik:'', postponed:0, postuntil:'', actionname:'',actionwithnote:false,
        nilaiPelunasan:0,tglPelunasan:0,
            finalNilaiPelunasan:0,finalTglPelunasan:'',type_memo:'',tipepelunasan:''},
        file:null,
        attachments:[], history:[],historyb4:[],titleb4:null,ttlmustpay:0,isPreview:true,
        pelunasanDetail:{},
        finalApproval:false,
        owneridx:0,
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFile() {
      this.$v.file.$touch();
      return this.$v.file.$invalid;
    },
    user(){
        return this.$store.state.user;
    }
  },
  created: async function(){
    toastr.info('Loading Appoval/Task Detail, please wait')
    if (this.$route.params.key)  {
          try {
                this.isLoading= true;
                this.taskname = this.$route.params.taskname;
                await pelunasan.printPDFMemoPelunasan(this.$route.params.taskkey)
                this.reportUrl = `${process.env.VUE_APP_BASE_API}/printpreview/pdf-filename/${this.$route.params.taskkey}`;
                if(this.taskname == "APPROVAL-Pembuatan Memo Pelunasan"){
                    this.isPreview = false;
                }else{
                    this.isPreview = true;
                }     
            
            const resp = await task.detail(this.$route.params);  
            const resPelunasanDetail = await pelunasan.detail(this.$route.params.taskkey);
            this.pelunasanDetail = resPelunasanDetail;
            this.model.pinjamankey = resPelunasanDetail.pinjamankey ? resPelunasanDetail.pinjamankey : '';
            toastr.clear;
            if (resp.success){
                const row = resp.data[0][0];
                if(row){
                    let ownerlistSplit = row.ownerlist.split(",");
                    let lastOwnerList = ownerlistSplit[ownerlistSplit.length-1]
                    this.owneridx = row.owneridx;
                    if(lastOwnerList.includes('|')){
                        let newArr = lastOwnerList.split('|');
                        let obj = newArr.find(x=>x===this.user.username)
                        if(obj){
                            this.finalApproval = true;
                        }
                    }else{
                        if(lastOwnerList==this.user.username){
                            this.finalApproval = true;
                        }
                    }
                }
                row.tahun = moment(row.createdon).format('YYYY');
                row.createdon = moment(row.createdon).format('dddd,  DD-MMM-YYYY hh:mm:ss');
                for (var key in row) {
                    this.model[key] = row[key];
                }
                // console.log('this.model : ',this.model);
                this.history = resp.data[1];
                this.attachments = resp.data[2];

                this.titleb4=resp.data[3][0] ? resp.data[3][0].p_titleb4 : "";
                this.historyb4=resp.data[4];
                this.ttlmustpay=resp.data[3][0] ? resp.data[3][0].p_ttlmustpay : "";

                this.model.nilaiPelunasan = resPelunasanDetail.ttlpayment_awal - resPelunasanDetail.ttlpayment_diskon 
                this.model.tglPelunasan = moment(resPelunasanDetail.tglpelunasan).format('YYYY-MM-DD');

                this.model.finalNilaiPelunasan = resPelunasanDetail.ttlpayment_awal - resPelunasanDetail.ttlpayment_diskon 
                this.model.finalTglPelunasan = moment(resPelunasanDetail.tglpelunasan).format('YYYY-MM-DD');

                this.model.type_memo = resPelunasanDetail.type_memo;
                this.model.tipepelunasan = resPelunasanDetail.tipepelunasan;
                this.reportbeforeUrl=  `${process.env.VUE_APP_BASE_API}/printpreview/pdf-filename/${resPelunasanDetail.referencekey}`;

            } else {
                console.log('error msg: ', resp.message);
                console.log('error Sql: ', resp.sql);
                toastr.error(JSON.stringify(resp), "ERROR MESSAGE");                              
            }
            this.isLoading= false
          } catch (error) {
            this.isLoading= false
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    } else {
          try {
            this.reportUrl = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/818087A0-9AF5-11E9-B25B-D1EDAAB41F0B`;
            const resp = await task.detail({key:'92b0564a-86f0-11e8-bc6e-1c394733789f'});  
            toastr.clear;
            if (resp.success){
                const row = resp.data[0][0];
                row.createdon = row.createdon ? moment(row.createdon).format('dddd , DD-MMM-YYYY hh:mm:ss') : '';
                for (var key in row) {
                    this.model[key] = row[key];
                }
                this.history = resp.data[1];
                this.attachments = resp.data[2];
            } else {
                console.log('error msg: ', resp.message);
                console.log('error Sql: ', resp.sql);
                toastr.error(JSON.stringify(resp), "ERROR MESSAGE");                              
            }
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }

    }
  },
  watch:{
    'model.finalNilaiPelunasan':function(val){
        // if(
        //     // (this.model.message||'')=='' && 
        //     (this.finalApproval)){
        //     this.model.message = `Setuju nilai pelunasan Rp. ${(this.model.finalNilaiPelunasan).toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 }) }`
        // }
    },
  },
  methods: {
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.taskkey);
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                this.attachments = response;

                this.showAddAttachment=false;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log(error);
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    viewBudgetProd : async function() {
        if (this.model.pjxhdrkey) {
            //   router.push({name :'budget.mstrbudgetprogress', params: { pjxhdrkey: this.model.pjxhdrkey}});
              let routeData = router.resolve({path: `/budget/progress-budget-production/${this.model.pjxhdrkey}`});
              window.open(routeData.href, '_blank');
        } else {
            toastr.warn(`it is not related to Budget Production/Project`);
        }
    },   
    viewBudgetDept2 : async function() {
        let routeData = router.resolve({path: `/budget/annual-budget-progress/${this.model.layout}/${this.model.departkd}/${this.model.departemen}/${moment(this.model.assignstr).format("YYYY-01-01")}/${moment(this.model.assignstr).endOf("month").format("YYYY-MM-DD")}`});
        window.open(routeData.href, '_blank');
    },   
    viewBudgetDept : async function() {
        this.isLoading=true;
        this.budgetUrl= await task.viewBudgetDept(this.model);
        this.isLoading=false;
        this.budgetTitle='Preview Budget Department';  
        this.budgetShow=true;
    },   
    showRouting: function(data) {
      this.model.isrouting=1;  
      this.showForm=true;
    },
    closeRouting(){
      this.model.isrouting=0;  
      this.model.routeToNik = '';
      this.showForm=false;
    },    
    async doRouting(){
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                this.isLoading=true;
                var param = {
                    taskassignkey: this.model.taskassignkey,
                    actionTake: 'ROUTING',
                    comment: this.model.message || (`Route to ${this.model.crewinfo}`),
                    isrouting: 1,
                    routeToNik: this.model.routeToNik,
                    routeToUser: this.model.routeToUser || '',
                    postponed: 0,
                    postuntil: ''
                }
                // console.log('doRouting action param:',param);
                const res= await task.doaction(param);
                this.isLoading=false;
                if (res.success == true) {
                    this.close();
                } else toastr.error(res.message);
                this.showForm=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    showQueuing: function(data) {
      this.model.isrouting=1;  
      this.showQueue=true;
    },
    closeQueuing(){
      this.model.isrouting=0;  
      this.model.routeToNik = '';
      this.showQueue=false;
    },    
    async doQueuing(){
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                this.isLoading=true;
                var param = {
                    taskassignkey: this.model.taskassignkey,
                    actionTake: 'PENDING',
                    comment: this.model.message || ('Queued, est. starting @' + moment(this.model.postuntil, 'YYYY-MM-DD').format('DD MMM YYYY')),
                    isrouting: 0,
                    routeToNik: '',
                    postponed: 1,
                    postuntil: this.model.postuntil
                }
                const res= await task.doaction(param);
                this.isLoading=false;
                if (res.success == true) {
                    this.close();
                } else toastr.error(res.message);
                this.showForm=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
      async doAction(actionname, actionwithnote = false) {
          try {
              this.model.actionname = actionname;
              this.model.actionwithnote = actionwithnote;

              if (this.owneridx > 0) {
                  this.model.message = '';
                  if (actionname == 'APPROVED' && !actionwithnote) {
                      this.model.message = 'Setuju sesuai rekomendasi / Setuju sesuai pengajuan Nasabah'
                  }
                  if (actionname == 'REJECTED') {
                      this.model.message = 'Tolak/Batal '
                  }
                  if (actionname == 'APPROVED' && actionwithnote) {
                      this.model.finalNilaiPelunasan = 0
                      if(this.model.tipepelunasan!='Normal') this.model.finalTglPelunasan = null;
                  }

                  this.showApprovalConfirm = true;

              } else {
                  if (this.invalidModel) {
                      console.log('validation : ', this.$v.model);
                      console.log('model : ', this.model);
                      toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                  } else {

                    this.showApprovalConfirm = true;

                  }
                  // this.model.message = ''
                  // if (actionname == 'APPROVED'){
                  //     this.model.message = 'Setuju sesuai rekomendasi / Setuju sesuai pengajuan Nasabah'
                  // }

              }

          } catch (error) {
              this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
          // if (this.invalidModel) {
          //       console.log('validation : ', this.$v.model);
          //       console.log('model : ',this.model);
          //     toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          // } else {
          //     try {

          //     } catch (error) {
          //         this.isLoading=false;
          //         if (error.message) {
          //             toastr.error(error.message);
          //         } else {
          //             toastr.error(JSON.stringify(error));
          //         }              
          //     }
          // }
      },
      approval: async function (evt) {
          evt.preventDefault()
          try {
              console.log('this.model.finalNilaiPelunasan',this.model.finalNilaiPelunasan)
              console.log('this.model.nilaiPelunasan',this.model.nilaiPelunasan)

              if(this.model.finalNilaiPelunasan < this.model.nilaiPelunasan ){
                toastr.error('Suggest Nilai Pelunasan Lebih Kecil Dari Pengajuan /Masukkan Nilai Pelunasan Yang Diharapkan ', "INFO MESSAGE");
              }else if (this.invalidModel) {
                  console.log('validation : ', this.$v.model);
                  console.log('model : ', this.model);
                  toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
              } 
              else {
                  this.showApprovalConfirm = false;
                  this.isLoading = true;
                  let newAction = this.model.actionwithnote ? 'SUGGEST' : this.model.actionname;

                  let param = {
                      taskassignkey: this.model.taskassignkey,
                      actionTake: this.model.actionname,
                      comment: this.model.message,
                      routeToNik: this.model.routeToNik || '',
                      routeToUser: this.model.routeToUser || '',
                      postponed: 0,
                      postuntil: '',
                      actiontakeLabel : newAction
                  };

                  if(this.model.actionwithnote){
                    param.finalNilaiPelunasan = this.model.finalNilaiPelunasan;
                    param.finalTglPelunasan = this.model.finalTglPelunasan;
                  }

                  const res = await task.doaction(param);
                  if (this.finalApproval && this.model.type_memo == 'normal' && this.model.actionwithnote) {
                      if ((this.model.finalNilaiPelunasan != this.model.nilaiPelunasan) ||
                          (this.model.finalTglPelunasan != this.model.tglPelunasan)
                      ) {
                          await pelunasan.approvalRevisi(this.model)
                      }
                  }
                  this.isLoading = false;
                  if (res.success == true) {
                      this.close();
                  } else toastr.error(res.message);
              }
          } catch (error) {
              this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message, 'ERROR MESSAGE', 10000);
              } else {
                  toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
              }
          }
      }, 
    onSelectLkuUser: async function (_selected) {
        this.model.crewinfo = _selected.crewnik.trim() + ' | ' + _selected.full_name.trim();
        this.model.crewkey = _selected.crewkey;
        this.model.routeToNik = _selected.crewnik.trim();
        this.model.routeToUser = _selected.username.trim();
        // console.log('model:',this.model);

        this.lkuUserShow=false;
    },
    viewrequestdetail(){
      const url = router.resolve({name:'loan.requestrrdview',params:{requestkey:this.$route.params.taskkey}}).route.path;
      return `#`+url;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'loan.approvalfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'loan.approval'});
        //   router.push("home");
      }
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
  }
};
</script>
